// extracted by mini-css-extract-plugin
module.exports = {"ticket-filling":"AppTicketFilling_ticket-filling__fNWOQ","filling-detail":"AppTicketFilling_filling-detail__IlNk6"};